import { render, staticRenderFns } from "./JoszakiCollapsibleCard.vue?vue&type=template&id=32a21c80"
import script from "./JoszakiCollapsibleCard.vue?vue&type=script&lang=js"
export * from "./JoszakiCollapsibleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports